import { useWidgetTimezone } from "@/features/shared/widget-context/widget-runtime-context";
import { localizeTime } from "@/features/shared/widgets/helpers";

const getFooterDates = (dates: Date[], timezone: string) => {
  const shownDates = new Set();

  return dates.reduce((acc, date) => {
    const localizedDate = localizeTime(date, "d MMM", timezone);
    const day = localizeTime(date, "d", timezone);

    if (!shownDates.has(day)) {
      shownDates.add(day);
      acc.push(String(localizedDate));
    } else {
      acc.push("");
    }

    return acc;
  }, [] as string[]);
};

const Footer = ({ dates }: { dates: Date[] }) => {
  const timezone = useWidgetTimezone();
  if (!timezone) return null;

  const tzOrOffset = timezone.name === "UTC" ? timezone.offset : timezone.name;
  const footerDates = getFooterDates(dates, tzOrOffset);

  return (
    <tfoot>
      {/* Render the hours row */}
      <tr>
        <th>uur</th>
        {dates.map((date) => {
          const hour = `${localizeTime(date, "H", tzOrOffset)}`;
          const showHour =
            dates.length < 18 ||
            (dates.length < 36 && parseInt(hour) % 2 === 0) ||
            parseInt(hour) % 4 === 0;
          return <td key={date.toISOString()}>{showHour ? hour : null}</td>;
        })}
      </tr>

      {/* Render the date at the beginning or when the date changes */}
      <tr>
        <th />
        {footerDates.map((date, i) => {
          return <td key={dates[i].toISOString()}>{date}</td>;
        })}
      </tr>
    </tfoot>
  );
};

export default Footer;
